export default "__VITE_PUBLIC_ASSET__95bd8bb1__"